var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sports-menu" }, [
    _vm.tabletAndAbove
      ? _c(
          "nav",
          [
            _c("site-navigation", {
              staticClass: "popular expand navigation",
              attrs: { "navigation-section": "BO_POPULAR" }
            }),
            _vm._v(" "),
            _c("main-navigation", { staticClass: " navigation" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "wrapper sports-az navigation" },
              [
                _c("h3", [_vm._v(" " + _vm._s(_vm.$t("Sports.AllSports")))]),
                _vm._v(" "),
                _c("bo-navigation", {
                  attrs: {
                    "p-idfwbonavigation": "top",
                    "order-by-name": true,
                    "preselect-first-node": false
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "nav",
          [
            [
              _c("ul", [
                _c("li", { staticClass: "live_link" }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToLive()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "pd-icon pd-icon-live" }),
                      _vm._v("EVENTS")
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wrapper sports-az navigation" },
                [
                  _c("bo-navigation", {
                    attrs: {
                      "p-idfwbonavigation": "top",
                      "order-by-name": true,
                      "preselect-first-node": false
                    }
                  })
                ],
                1
              )
            ]
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-489dc3b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-489dc3b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SportsMenu.vue
// module id = null
// module chunks = 